<template>
  <div class="cookPattenPage">
    <div>
      <el-tag class="tagDIV">{{ $t('Common.stage') }}{{ cookPhaseObj.index + 1 }}</el-tag>
      <span class="title">{{ $t('RecipeManage.listCookingPattern2') }}</span>
    </div>
    <div>
      <div class="formContent">
        <div class="spanTitle">{{ $t('RecipeManage.listTips9') }}(30~260℃):</div>
        <el-input-number
          class="speInput"
          v-model="patten1.temperature"
          controls-position="right"
          :min="30"
          :max="260"
          @change="handleTemperature"
        ></el-input-number>
        <span class="solidUnit">℃</span>
        <span class="Funit"> ({{ CToF(patten1.temperature) }}℉)</span>
      </div>
      <!--      <div class="formContent">-->
      <!--        <div class="spanTitle">{{ $t('RecipeManage.listTips4') }}:</div>-->
      <!--        <el-input-number class='speInput' v-model="patten1.temperature" controls-position="right"  :min="30" :max="260"></el-input-number>-->
      <!--      </div>-->
      <!--      <div class="formContent">-->
      <!--        <div class="spanTitle">{{ $t('RecipeManage.listTips7') }}:</div>-->
      <!--        <el-input-number class='speInput' v-model="patten1.centerTemperature" controls-position="right"  :min="30" :max="120"></el-input-number>-->
      <!--      </div>-->

      <div class="formContent">
        <div class="spanTitle">{{ $t('RecipeManage.listTips7') }}(30~120℃):</div>
        <el-input-number
          class="speInput"
          v-model="patten1.centerTemperature"
          controls-position="right"
          :min="30"
          :max="120"
        ></el-input-number>
        <span class="solidUnit">℃</span>
        <span class="Funit"> ({{ CToF(patten1.centerTemperature) }}℉)</span>
      </div>
      <div class="formContent">
        <div class="spanTitle">
          {{ $t('RecipeManage.listTips5') }}{{ `(${humiSliderMin}~${humiSliderMax}%)` }}:
        </div>
        <el-slider
          class="sliderInput"
          :format-tooltip="formatSlider"
          :step="10"
          :min="humiSliderMin"
          :max="humiSliderMax"
          :marks="marksOfMoisture"
          show-stops
          v-model="patten1.humidity"
        >
        </el-slider>
        <el-input-number
          class="speInput"
          :min="humiSliderMin"
          :max="humiSliderMax"
          v-model="patten1.humidity"
          :step="10"
          size="small"
          step-strictly
        ></el-input-number>
        <span class="solidUnit">%</span>
      </div>
      <div class="formContent">
        <div class="spanTitle">{{ $t('RecipeManage.listTips6') }}:</div>
        <el-slider
          class="sliderInput"
          :step="10"
          :min="30"
          :max="100"
          show-stops
          v-model="patten1.fanRotateSpeed"
          :marks="marksOfDraughtFan"
        >
        </el-slider>
        <el-input-number
          class="speInput"
          :min="30"
          :max="100"
          v-model="patten1.fanRotateSpeed"
          :step="10"
          size="small"
          step-strictly
        ></el-input-number>
        <span class="solidUnit">{{ $t('RecipeManage.listRotateSpeed') }}</span>
      </div>

      <div class="formContent" style="margin-bottom: 0;">
        <div class="spanTitle"></div>
        <el-radio-group v-model="patten1.fanDirection">
          <el-radio label="ProsAndCons">{{ $t('RecipeManage.listProsAndCons') }}</el-radio>
          <el-radio label="Pros">{{ $t('RecipeManage.listPros') }}</el-radio>
        </el-radio-group>
      </div>
      <div class="formContent" style="margin-bottom: 0;margin-top: 0">
        <div class="spanTitle"></div>
        <el-radio-group v-model="patten1.fanState">
          <el-radio label="OFF">{{ $t('RecipeManage.listOFF') }}</el-radio>
          <el-radio label="ON">{{ $t('RecipeManage.listON') }}</el-radio>
        </el-radio-group>
      </div>
      <div class="formContent" style="margin-top: 0">
        <div class="spanTitle">{{ $t('RecipeManage.listPause') }}:</div>
        <el-radio-group v-model="patten1.suspendState">
          <el-radio label="Unsuspended">{{ $t('RecipeManage.listUnsuspended') }}</el-radio>
          <el-radio label="Pause">{{ $t('RecipeManage.listPause') }}</el-radio>
        </el-radio-group>
      </div>
      <div class="formContent" style="height: 80px;align-items: baseline">
        <div class="spanTitle">
          {{ $t('RecipeManage.listStageDes') }}{{ `(${$t('Common.optional')})` }}:
        </div>
        <el-input
          type="textarea"
          :rows="4"
          v-model="patten1.remark"
          :placeholder="$t('RecipeManage.listStageDes')"
        ></el-input>
      </div>
    </div>
  </div>
</template>

<script>
import { CToF } from '@/utils/utils'
export default {
  name: 'cookPattenMid',
  props: {
    cookPhaseObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      patten1: {
        temperature: 100,
        centerTemperature: 30,
        time: '',
        humidity: '',
        fanRotateSpeed: 80,
        fanDirection: 'ProsAndCons',
        fanState: 'OFF',
        suspendState: 'Unsuspended',
        remark: '',
        flowType: this.cookPhaseObj.flowType,
        stageName: this.cookPhaseObj.stageName
      },
      marksOfMoisture: {
        0: '0',
        10: '10',
        20: '20',
        30: '30',
        40: '40',
        50: '50',
        60: '60',
        70: '70',
        80: '80',
        90: '90',
        100: '100'
      },
      marksOfDraughtFan: {
        30: '30',
        40: '40',
        50: '50',
        60: '60',
        70: '70',
        80: '80',
        90: '90',
        100: '100'
      },
      humiSliderMin: 0,
      humiSliderMax: 100
    }
  },
  created() {
    this.patten1 = {
      ...this.patten1,
      ...this.cookPhaseObj,
      humidity: parseInt(this.cookPhaseObj.humidity),
      fanRotateSpeed: parseInt(this.cookPhaseObj.fanRotateSpeed)
    }
    this.$nextTick(() => {
      this.handleTemperature(this.patten1.temperature)
    })
  },
  methods: {
    CToF,
    formatSlider(value) {
      return value + '%'
    },
    handleTemperature(val) {
      if (val > 229) {
        this.humiSliderMax = 10
        if (this.patten1.humidity > 10) {
          this.this.patten1.humidity = 10
        }
      } else if (val > 199 && val < 230) {
        this.humiSliderMax = 20
        if (this.patten1.humidity > 20) {
          this.this.patten1.humidity = 20
        }
      } else if (val > 129 && val < 200) {
        this.humiSliderMax = 30
        if (this.patten1.humidity > 30) {
          this.this.patten1.humidity = 30
        }
      } else if (val < 130) {
        this.humiSliderMax = 100
      }
      console.log(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.cookPattenPage {
  margin-top: 8px;
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  padding: 24px;
  .tagDIV {
    border: 0;
    font-weight: 600;
    font-size: 12px;
    line-height: 26px;
    height: 26px;
    border-radius: 13px;
  }
  .title {
    margin-left: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 20px;
  }
  .formContent {
    margin: 24px 0;
    height: 40px;
    display: flex;
    align-items: center;
    .spanTitle {
      text-align: right;
      min-width: 165px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
      padding-right: 12px;
    }
    .Funit {
      font-size: 16px;
      margin-left: 8px;
      color: #999999;
    }
  }
  .speInput {
    width: 120px !important;
  }
  .sliderInput {
    width: 340px;
    margin-right: 24px;
  }
  .solidUnit {
    padding-left: 4px;
    color: #333333;
    line-height: 36px;
  }
}
</style>
